<template>
  <slot />
  <tree-item v-if="node?.children?.length > 0" v-for="(child, idx) in node?.children" :node="child" :treeNode="treeNode" :depth="depth + 1">
    <component :is="treeNode" :node="child" :depth="depth + 1"/>
  </tree-item>
</template>

<script setup>

import TreeItem from './TreeItem';

const props = defineProps({node: Object, depth: Number, treeNode: Object});

</script>

<style lang="scss" scoped>
</style>
